import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reset-form"
export default class extends Controller {
  clear(event) {
      if (event && event.detail && !event.detail.success) return

      this.element.reset()
      this.resetDropzone()
    }
    
    // Reset the dropzone controller
    resetDropzone() {
      
      const dropzoneElement = this.element.closest('[data-controller~="dropzone"]')
      if (dropzoneElement) {
        const dropzoneController = this.application.getControllerForElementAndIdentifier(dropzoneElement, 'dropzone')
        if (dropzoneController) {
          dropzoneController.reset()
        }
      }
    }
}
